<template>
  <div v-if="visible" class="modal d-block" style="background:rgba(0,0,0,.4);" tabindex="-1">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button type="button" class="btn-close" @click="close"></button>
        </div>
        <div class="modal-body">
          <div v-if="loading" class="text-center">
            <div class="spinner-border" role="status"></div>
          </div>
          <div v-else-if="diff.emptyText" class="alert alert-info">{{ diff.emptyText }}</div>
          <template v-else>
            <div v-for="notice in diff.notices" :key="notice" class="alert alert-secondary mb-2">{{ notice }}</div>
            <DiffViewer
              :old-content="diff.previous ?? ''"
              :new-content="diff.current"
              :old-label="diff.oldLabel"
              :new-label="diff.newLabel"
            />
          </template>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="close">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';

const EMPTY_DIFF = {
  previous: null,
  current: '',
  oldLabel: 'Previous version',
  newLabel: 'Current version',
  notices: [],
  emptyText: null,   // set -> shown instead of the diff (e.g. "No previous version saved yet.")
};

// One popup for every diff: the caller gives a title and a loader that resolves to
// { previous, current, oldLabel?, newLabel?, notices?, emptyText? }. Loading, closing and
// error handling live here; errors are emitted so the view can show its own error modal.
export default {
  name: 'DiffModal',
  components: {
    // Loaded on demand, so the CodeMirror bundle stays out of every page until a diff opens
    DiffViewer: defineAsyncComponent(() => import('@/components/DiffViewer.vue')),
  },
  emits: ['error'],
  data() {
    return { visible: false, loading: false, title: '', diff: { ...EMPTY_DIFF } };
  },
  methods: {
    async open(title, loader) {
      this.title = title;
      this.diff = { ...EMPTY_DIFF };
      this.visible = true;
      this.loading = true;
      try {
        this.diff = { ...EMPTY_DIFF, ...(await loader()) };
      } catch (e) {
        this.visible = false;
        this.$emit('error', e.message);
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.visible = false;
    },
  },
};
</script>
